export function eventDeleteError(result) {
  const data = result?.response?.data ?? result?.data ?? result;
  const detail = data?.detail || (data !== result || !result?.isAxiosError ? data?.message : null);
  if (typeof detail === 'string' && detail.trim()) return detail.trim().slice(0, 700);
  if (Array.isArray(detail)) {
    const message = detail.filter(value => typeof value === 'string').join(' ');
    if (message) return message.slice(0, 700);
  }
  const status = result?.response?.status;
  if (status === 401) return 'Войдите в систему повторно.';
  if (status === 403) return 'Недостаточно прав для удаления события.';
  if (status === 404) return 'Событие не найдено. Обновите список — возможно, оно уже удалено.';
  if (status === 409) return 'Данные события изменились. Обновите карточку и повторите действие.';
  if (result?.code === 'ERR_NETWORK' || result?.code === 'ECONNABORTED') {
    return 'Связь прервалась. Обновите список, чтобы проверить, удалено ли событие.';
  }
  return 'Не удалось удалить событие. Обновите список и повторите действие.';
}
